<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Group</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :codes="classGroups" :showDesc="false" v-model="classGroup" />
				</span>
				<em class="lt_text">Category</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :width="100" :codeWidth="110" :nameWidth="500" :codes="categories" :showDesc="false" v-model="category_code" />
				</span>
				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" :codeWidth="100" @set-item-class="setSearchClass" /> </span>
				<em v-if="profile.use_size_code == 'Y'" class="lt_text">Color </em>
				<span v-if="profile.use_size_code == 'Y'" class="int_type_no_border mgr_5">
					<CodeSelect className="tbl_select sm_int" :width="100" :codeWidth="100" :showDesc="false" codeType="COL" :codes="colors" v-model="color_code" />
				</span>

				<span class="int_type mgr_15">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span v-if="isJC" class="int_type_no_border mgr_5">
					<ItemClassSelectMultiS :key="item_class_component_key" :multiSelect="true" :syncWithString="true" :hideClassesString="true" v-model="item_classes_string" />
				</span>
				<span class="int_type" style="width:140px;">
					<input type="text" v-model="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type" style="width:50px;">
					<input type="text" v-model="rack" placeholder="Rack" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type mgr_15" style="width:55px;">
					<input type="text" v-model="section" placeholder="Section" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<label for="null_barcode" class="mgr_15"> <input type="checkbox" id="null_barcode" v-model="null_barcode" /> Empty Barcode</label>
				<em class="lt_text">On Hand</em>
				<span class="int_type">
					<select v-model="on_hand_condition" class="tbl_select sm_int">
						<option :value="null"></option>
						<option value="less_than">&lt;</option>
						<option value="equal">=</option>
						<option value="greater_than">&gt;</option>
					</select>
				</span>
				<span class="int_type mgr_15 " style="width:60px;">
					<currency-input type="text" class="al_right" :precision="0" v-model="on_hand_quantity" autocomplete="off" />
				</span>
				<label for="under_reorder_level" class="mgr_15"> <input type="checkbox" id="under_reorder_level" v-model="under_reorder_level" /> Under Reorder Level</label>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
			<div v-if="isJC" class="left_option">
				<em class="lt_text">Selected Item {{ headers.class }}</em>
				<textarea rows="3" v-model.trim="item_classes_string" class="textarea_type" style="display:inline-block; vertical-align:middle; width: 70%;" @focus="$event.target.select()" @input="item_class_component_key++" />
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big4_tbl">
				<div style="height: 630px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
						<thead>
							<tr>
								<th v-if="user.company_id == 'jc'" style="text-align:center;width:25px;"><input type="checkbox" v-model="all_selected" @change="toggleSelectAll" @click.stop /></th>
								<th style="text-align:center;width:20px;"></th>
								<th style="text-align:center;width:70px;">Item ID</th>
								<th style="text-align:center;width:140px;">Item Code</th>
								<th v-if="!isJC" style="text-align:center;width:120px;">Color Code</th>
								<th v-if="user.company_id == 'he'" style="text-align:center;width:120px;">Color Name</th>
								<!-- <th style="text-align:center;width:20%;">Class Code</th> -->
								<th v-if="profile.use_size_code == 'Y'" style="text-align:center;width:60px;">Size</th>
								<th style="text-align:center;">Name</th>
								<th style="text-align:center;width:45px;">Pack</th>
								<th v-if="user.company_id == 'jc'" style="text-align:center;width:45px;">Pack(C)</th>
								<th style="text-align:center;width:45px;">Unit</th>

								<th style="text-align:center;width:55px;">Lock($)</th>
								<th style="text-align:center;width:55px;">Min($)</th>
								<th v-if="user.company_id == 'he'" style="text-align:center;width:55px;">B($)</th>

								<th style="text-align:center;width:55px;" v-if="user.cost_view_yn == 'Y'">Cost($)</th>

								<!-- <th style="text-align:center;width:4%;">S P.($)</th>
							<th style="text-align:center;width:4%;">A P.($)</th>
							<th style="text-align:center;width:4%;">B P.($)</th>
							<th style="text-align:center;width:4%;">C P.($)</th> -->

								<th style="text-align:center;width:60px;">Loc.</th>
								<th style="text-align:center;width:55px;">Rack</th>
								<th style="text-align:center;width:45px;">Sec.</th>
								<th style="text-align:center;width:100px;">Barcode</th>

								<template v-if="user.company_id == 'jc'">
									<th style="text-align:center;width:65px;">WH1</th>
									<th style="text-align:center;width:65px;">WH2</th>
									<th style="text-align:center;width:65px;">N/D</th>
								</template>

								<th style="text-align:center;width:70px;">On Hand</th>

								<!-- <th style="text-align:center;width:3%;">Closed</th> -->
								<th style="text-align:center;width:25px;">Active</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="item in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id == selectedItem.item_id }" @click="selectRow(item)">
								<td v-if="user.company_id == 'jc'" class="al_center" @click.stop><input type="checkbox" v-model="item.selected" /></td>
								<td class="al_center"><img v-img v-if="item.image_file_name" :src="getImageUrl(item)" alt="File Not Found" style="cursor: zoom-in;max-height:20px;max-width:20px;height:auto;width:auto;" /></td>
								<td>{{ item.item_id }}</td>
								<td class="truncate">{{ item.item_code }}</td>
								<td v-if="!isJC">{{ item.color_code }}</td>
								<td v-if="user.company_id == 'he'">{{ item.color_name }}</td>
								<!-- <td>{{ item.class_code }}</td> -->
								<td v-if="profile.use_size_code == 'Y'">{{ item.size_code }}</td>
								<td class="truncate">{{ item.name }}</td>
								<td style="text-align:right;">{{ item.packing }}</td>
								<td v-if="user.company_id == 'jc'" style="text-align:right;">{{ item.case_packing }}</td>
								<td>{{ item.unit_code }}</td>

								<td style="text-align:right;">{{ item.lock_price | toCurrency }}</td>
								<td style="text-align:right;">{{ item.min_price | toCurrency }}</td>
								<td v-if="user.company_id == 'he'" style="text-align:right;">{{ item.b_price | toCurrency }}</td>
								<td style="text-align:right;" v-if="user.cost_view_yn == 'Y'">{{ item.cost | toCurrency }}</td>

								<!-- <td style="text-align:right;">{{ item.s_price | toCurrency }}</td>
							<td style="text-align:right;">{{ item.a_price | toCurrency }}</td>
							<td style="text-align:right;">{{ item.b_price | toCurrency }}</td>
							<td style="text-align:right;">{{ item.c_price | toCurrency }}</td> -->

								<td>{{ item.location_name }}</td>
								<td>{{ item.rack }}</td>
								<td>{{ item.section }}</td>
								<td>{{ item.barcode }}</td>

								<template v-if="user.company_id == 'jc'">
									<td style="text-align:right;">
										<currency-input
											type="text"
											:style="item.WH1_changed ? 'border:1px solid red' : 'border:1px solid #ddd'"
											v-model.trim="item.WH1_new"
											:precision="0"
											class="r_int long_type al_right"
											@focus="$event.target.select()"
											@input="calNewOnHand(item)"
										/>
									</td>
									<td style="text-align:right;">
										<currency-input
											type="text"
											:style="item.WH2_changed ? 'border:1px solid red' : 'border:1px solid #ddd'"
											v-model.trim="item.WH2_new"
											:precision="0"
											class="r_int long_type al_right"
											@focus="$event.target.select()"
											@input="calNewOnHand(item)"
										/>
									</td>
									<td style="text-align:right;">
										<currency-input
											type="text"
											:style="item.WH_NULL_changed ? 'border:1px solid red' : 'border:1px solid #ddd'"
											v-model.trim="item.WH_NULL_new"
											:precision="0"
											class="r_int long_type al_right"
											@focus="$event.target.select()"
											@input="calNewOnHand(item)"
										/>
									</td>
								</template>

								<td v-if="user.company_id != 'jc'" style="text-align:right;">
									<currency-input type="text" :style="item.changed ? 'border:1px solid red' : 'border:1px solid #ddd'" v-model.trim="item.new_on_hand" :precision="0" class="r_int long_type al_right" @focus="$event.target.select()" />
								</td>
								<td v-else style="text-align:right;">
									<span>{{ item.new_on_hand | commaSeparated }} </span>
								</td>
								<!-- <td style="text-align:right;">{{ item.on_hand | commaSeparated }}</td> -->

								<!-- <td style="text-align:center;">{{ item.closed_yn }}</td> -->
								<td style="text-align:center;">{{ item.active_yn }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="excel()">Excel</a>
					<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="excelSBM()">SBM Excel</a>
					<a v-if="user.company_id == 'arkin'" href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="inventoryReport()">Inventory Report(Excel)</a>
					<template v-if="user.company_id == 'jc'">
						<label for="input-file">Upload Item</label>
						<input type="file" ref="import_file" id="input-file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="readFile" />
						<!-- <a href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="uploadItem()">Upload File</a>
						<input type="file" v-show="false" ref="uploadItem" class="file_input_hidden" accept="image/*" @change="uploadItemConfirm()" /> -->
						<a href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="inactivateSelected()">Inactive Selected</a>
						<a href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="activateSelected()">Active Selected</a>
					</template>
					<a v-if="modifiable" href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="bulkPictureFolderPick()">Bulk Upload Pictures</a>
					<input type="file" v-show="false" ref="bulkPictureInput" class="file_input_hidden" accept="image/*" multiple webkitdirectory directory @change="bulkPictureFolderSelected()" />

					<span v-if="use_shopify" class="fl_l mgr_15">
						<span class="int_type">
							<select v-model="selected_store_no" class="tbl_select sm_int">
								<option v-for="store in shopify_store_list" :key="store.store_no" :value="store.store_no">{{ store.store_name }}</option>
							</select>
						</span>
						<a href="javascript:;" type="button" class="gray_bt" @click="excelComparingWithShopify()">Shopify Info.</a>
					</span>

					<span class="int_type_no_border mgr_15">
						<PageSizeSelect v-model="page_size" @input="search()" />
					</span>
					<a href="javascript:;" :class="selectedItem.item_id && mode == 'detail' ? 'gray_bt' : 'disable_bt'" style="margin-right:15px" @click="inventoryHistory()">Inventory History</a>
					<span v-if="modifiable" class="int_type mgr_5">
						<select v-model="adjust_reason" class="tbl_select sm_int">
							<option value="adjust">Inventory Adjust</option>
							<option value="damage">Damage Loss</option>
							<option value="missing">Missing</option>
						</select>
					</span>
					<a v-if="modifiable" href="javascript:;" class="gray_bt" style="margin-right:15px" @click="adjustInventory()">Adjust On-Hand</a>
					<a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
					<a v-if="modifiable" href="javascript:;" :class="selectedItem.item_id && mode == 'detail' ? 'gray_bt' : 'disable_bt'" @click="clone()">Clone</a>
				</div>
			</div>

			<div class="right_small4_tbl">
				<h4 class="inner_h5">{{ detailTitle }}</h4>
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:90px;" />
						<col style="" />
						<col style="width:90px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr v-if="user.admin_yn == 'Y'">
							<td colspan="4">Created : {{ item.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ item.crt_user }}</td>
						</tr>
						<tr v-if="user.admin_yn == 'Y'">
							<td colspan="4">Last updated : {{ item.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ item.upd_user }}</td>
						</tr>
						<tr>
							<th>{{ headers.class }} Code</th>
							<td colspan="2">
								<ItemClassSelect :codeWidth="100" v-model.trim="item.class_code" :disabled="mode == 'detail'" :showName="false" @set-item-class="setItemClass" />
								<template v-if="item.wh_class_code"> , {{ item.wh_class_code }}-{{ item.wh_color_code }} </template>
							</td>
							<td v-if="profile.use_repack == 'Y'">
								<label for="repack" style="margin-left:5px;"> <input type="checkbox" id="repack" v-model="item.repack" />Repack / Subd.</label>
							</td>
						</tr>
						<tr>
							<th>{{ headers.class }} Name</th>
							<td colspan="3"><input type="text" v-model.trim="item.class_name" class="tbl_int full_int" disabled="true" /></td>
						</tr>
						<tr>
							<th>Item ID</th>
							<td>
								<input type="text" v-model.trim="item.item_id" ref="code" class="tbl_int sm_int" disabled="true" />
								<!-- <input type="text" v-model.trim="item.item_id" ref="code" class="tbl_int sm_int" v-bind:disabled="mode == 'detail'" /> -->
								<!-- <button v-if="mode == 'add'" v-bind:disabled="!item.item_id" class="gray_bt" @click="checkDup()">Check Dup.</button> -->
							</td>
							<th>Factory Code</th>
							<td>
								<input type="text" v-model.trim="item.factory_code" class="tbl_int sm_int" />
							</td>
						</tr>
						<tr>
							<th>Item Code</th>
							<td colspan="3">
								<input type="text" v-model.trim="item.item_code" class="tbl_int mm_int" disabled="true" />
								<button v-if="mode == 'add'" v-bind:disabled="!item.item_code" class="gray_bt" @click="checkDup()">Check Dup.</button>
								<button v-if="mode == 'detail'" class="gray_bt" @click="setDefaultItemCodeAndName()">Reset</button>
							</td>

							<!-- <td><input type="text" v-model.trim="item.item_code" class="tbl_int sm_int" v-bind:disabled="mode == 'detail'" /></td> -->
						</tr>
						<tr v-if="profile.amazon == 'Y'">
							<th>Amazon Code</th>
							<td colspan="3">
								<input type="text" v-model.trim="item.amazon_code" class="tbl_int mm_int" />
							</td>
						</tr>
						<tr v-if="profile.deco == 'Y'">
							<th>Deco Code</th>
							<td colspan="2">
								<input type="text" v-model.trim="item.deco_code" class="tbl_int mm_int" />
							</td>
						</tr>
						<tr v-if="!isJC">
							<th>Color</th>
							<td colspan="3">
								<!-- <CodeSelect className="tbl_select sm_int" :width="120" :codeWidth="140" :codes="colors" v-model="item.color_code" v-bind:disabled="mode == 'detail'" @set-code="setColor" /> -->
								<!-- <CodeSelect className="tbl_select sm_int" :width="83" :codeWidth="100" :codes="colors" v-model="item.color_code" @set-code="setColor" /> -->
								<CodeSelect className="tbl_select sm_int" :width="140" :codeWidth="140" :showDesc="false" codeType="COL" :newMakable="true" :codes="colors" v-model="item.color_code" @set-code="setColor" />
							</td>
						</tr>
						<tr v-if="profile.use_size_code == 'Y'">
							<th>Size</th>
							<td colspan="3">
								<CodeSelect className="tbl_select sm_int" :width="140" :codeWidth="140" :showDesc="false" codeType="SIZ" :codes="sizes" v-model="item.size_code" @set-code="setSize" />
							</td>
						</tr>
						<tr>
							<th>Name</th>
							<td colspan="3"><input type="text" v-model.trim="item.name" class="tbl_int full_int" /></td>
							<!-- <td><input type="text" v-model.trim="computedName" class="tbl_int full_int" /></td> -->
						</tr>
						<tr>
							<th>Packing<template v-if="user.company_id == 'jc'">(B/C)</template></th>
							<td>
								<!-- <money type="text" v-model.trim="item.packing" class="tbl_int ssm_int al_right" /> -->
								<template v-if="user.company_id == 'jc'">
									<currency-input type="text" v-model.trim="item.packing" :precision="0" :allow-negative="false" class="tbl_int sss2m_int al_right" />
									<currency-input type="text" v-model.trim="item.case_packing" :precision="0" :allow-negative="false" class="tbl_int sss2m_int al_right" />
								</template>
								<template v-else>
									<currency-input type="text" v-model.trim="item.packing" :precision="0" :allow-negative="false" class="tbl_int ssm_int al_right" />
								</template>
							</td>
							<th>Unit</th>
							<td><CodeSelect className="tbl_select" :width="53" :descWidth="50" :codes="units" v-model="item.unit_code" /></td>
						</tr>
						<tr v-if="user.company_id == 'jc'">
							<th></th>
							<td></td>
							<th>Purchase Unit</th>
							<td><CodeSelect className="tbl_select" :width="53" :descWidth="50" :codes="units" v-model="item.purchase_unit_code" /></td>
						</tr>
						<tr>
							<th>Weight(LBS)</th>
							<td><currency-input type="text" v-model.trim="item.weight_per_box" :allow-negative="false" class="tbl_int ssm_int al_right" /><span v-if="user.company_id != 'he'"> per 1 box</span></td>
							<th><span v-if="user.company_id != 'he'">Box</span><span v-else>Size</span> (L/W/H)</th>
							<td>
								<currency-input type="text" v-model.trim="item.box_length" :allow-negative="false" :precision="1" class="tbl_int sss2m_int al_right" />/
								<currency-input type="text" v-model.trim="item.box_width" :allow-negative="false" :precision="1" class="tbl_int sss2m_int al_right" />/
								<currency-input type="text" v-model.trim="item.box_height" :allow-negative="false" :precision="1" class="tbl_int sss2m_int al_right" />
							</td>
						</tr>
						<tr v-if="user.cost_view_yn == 'Y' && user.fob_price_view">
							<th colspan="3">Last Shipment Price</th>
							<td><currency-input type="text" :readonly="true" v-model.trim="item.last_sh_price" :allow-negative="false" class="tbl_int sssm_int al_right" /></td>
						</tr>
						<tr v-if="user.cost_view_yn == 'Y' && user.fob_price_view">
							<th>FOB Cost</th>
							<td><currency-input type="text" v-model.trim="item.fob" class="tbl_int sssm_int al_right" @input="adjustCost(item)" /></td>
							<th>Tariff Rate (%)</th>
							<td><currency-input type="text" v-model.trim="item.tariff_rate" :precision="1" :valueRange="{ min: 0, max: 99.9 }" class="tbl_int sssm_int al_right" @input="adjustCost(item)" /></td>
						</tr>
						<tr>
							<th>Cost</th>
							<td><currency-input type="text" v-if="user.cost_view_yn == 'Y'" v-model.trim="item.cost" :readonly="fob_cost_link" class="tbl_int sssm_int al_right" @input="adjustPrice(item)" /></td>
							<th>Discount Price</th>
							<td>
								<currency-input type="text" v-model.trim="item.discount_price" class="tbl_int sssm_int al_right" />
								<span v-if="user.cost_view_yn == 'Y' && item.discount_price > 0">{{ getPricePercent(item.discount_price) }}%</span>
							</td>
						</tr>
						<tr>
							<th>Lock Price</th>
							<td>
								<currency-input type="text" v-model.trim="item.lock_price" class="tbl_int sssm_int al_right" />
								<span v-if="user.cost_view_yn == 'Y' && item.lock_price > 0">{{ getPricePercent(item.lock_price) }}%</span>
							</td>
							<th>Min Price</th>
							<td>
								<!-- <currency-input type="text" v-model.trim="item.min_price" class="tbl_int sssm_int al_right" :valueRange="{ min: item.lock_price }" /> -->
								<currency-input type="text" v-model.trim="item.min_price" class="tbl_int sssm_int al_right" />
								<span v-if="user.cost_view_yn == 'Y' && item.min_price > 0">{{ getPricePercent(item.min_price) }}%</span>
							</td>
						</tr>
						<tr>
							<th>S Price</th>
							<td>
								<currency-input type="text" v-model.trim="item.s_price" class="tbl_int sssm_int al_right" :valueRange="{ min: 0 }" />
								<span v-if="user.cost_view_yn == 'Y' && item.s_price > 0">{{ getPricePercent(item.s_price) }}%</span>
							</td>
							<th>A Price</th>
							<td>
								<!-- <currency-input type="text" v-model.trim="item.a_price" class="tbl_int sssm_int al_right" :valueRange="{ min: item.min_price }" /> -->
								<currency-input type="text" v-model.trim="item.a_price" class="tbl_int sssm_int al_right" @input="syncMinPriceFromA(item)" />
								<span v-if="user.cost_view_yn == 'Y' && item.a_price > 0">{{ getPricePercent(item.a_price) }}%</span>
							</td>
						</tr>
						<tr>
							<th>B Price</th>
							<td>
								<!-- <currency-input type="text" v-model.trim="item.b_price" class="tbl_int sssm_int al_right" :valueRange="{ min: item.a_price }" /> -->
								<currency-input type="text" v-model.trim="item.b_price" class="tbl_int sssm_int al_right" />
								<span v-if="user.cost_view_yn == 'Y' && item.b_price > 0">{{ getPricePercent(item.b_price) }}%</span>
							</td>
							<th>C Price</th>
							<td>
								<!-- <currency-input type="text" v-model.trim="item.c_price" class="tbl_int sssm_int al_right" :valueRange="{ min: item.b_price }" /> -->
								<currency-input type="text" v-model.trim="item.c_price" class="tbl_int sssm_int al_right" />
								<span v-if="user.cost_view_yn == 'Y' && item.c_price > 0">{{ getPricePercent(item.c_price) }}%</span>
							</td>
						</tr>
						<tr>
							<th>Location</th>
							<td colspan="3"><CodeSelect className="tbl_select" :width="83" :codes="locations" v-model="item.location_code" /></td>
						</tr>
						<tr>
							<th>Rack</th>
							<td><input type="text" v-model.trim="item.rack" class="tbl_int ssm_int" /></td>
							<th>Section</th>
							<td><input type="text" v-model.trim="item.section" class="tbl_int ssm_int" /></td>
						</tr>
						<template v-if="user.company_id == 'jc'">
							<tr>
								<th>Customer Ref UPC</th>
								<td colspan="3">
									<input type="text" v-model.trim="item.barcode" class="tbl_int ssm2_int" />
								</td>
							</tr>
							<tr>
								<th>UPC #1 (BX)</th>
								<td>
									<input type="text" v-model.trim="item.barcode_box" class="tbl_int ssm2_int" />
								</td>
								<th>Unit Note #1</th>
								<td><input type="text" v-model.trim="item.unit_note1" class="tbl_int ssm_int" /></td>
							</tr>
							<tr>
								<th>UPC #2 (CS)</th>
								<td>
									<input type="text" v-model.trim="item.barcode_case" class="tbl_int ssm2_int" />
								</td>
								<th>Unit Note #2</th>
								<td><input type="text" v-model.trim="item.unit_note2" class="tbl_int ssm_int" /></td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<th>Barcode</th>
								<td colspan="3">
									<input type="text" v-model.trim="item.barcode" class="tbl_int ssm2_int" />
									<a v-if="showCreateBarcodeButton" href="javascript:;" class="gray_bt" @click="createBarcode()">Create Barcode</a>
								</td>
							</tr>
						</template>

						<tr>
							<th>On Hand</th>
							<td colspan="1">
								<!-- <input type="text" v-mask="'######'" v-model.trim="item.on_hand" class="tbl_int ssm_int al_right" /> -->
								<!-- <currency-input type="text" precision="2" valueAsInteger="true" v-model.trim="item.on_hand" class="tbl_int ssm_int al_right" /> {{ item.on_hand }} -->
								<!-- <money type="text" v-model.trim="item.on_hand" class="tbl_int ssm_int al_right"></money> -->
								<currency-input type="text" v-model.trim="item.on_hand" :precision="0" class="tbl_int ssm_int al_right" readonly />
								<a v-if="isValid" href="javascript:;" class="gray_bt" @click="viewLot()">Detail</a>
							</td>
							<th>Reorder Level</th>
							<td colspan="1">
								<currency-input type="text" v-model.trim="item.reorder_level" :precision="0" class="tbl_int ssm_int al_right" />
							</td>
						</tr>

						<tr>
							<th style="height:120px;">Picture</th>
							<td colspan="2">
								<img v-img v-if="item.image_file_name" :src="getImageUrl(item)" alt="File Not Found" style="cursor: zoom-in;max-height:70px;max-width:170px;height:auto;width:auto;" />
							</td>
							<td>
								<button :disabled="mode == 'add' || !selectedItem.item_id" class="btn" @click="uploadFile()">{{ !item.image_file_name ? 'Upload' : 'Replace' }} File</button>
								<input type="file" v-show="false" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />
								<br />
								<button :disabled="!item.image_file_name" class="btn" style="margin-top:10px;" @click="clear()">Clear Picture</button>
							</td>
						</tr>
						<tr>
							<th></th>
							<td colspan="3">
								<label for="active_yn" style="margin-left:15px;">
									<input type="checkbox" id="active_yn" v-model="item.active_yn" true-value="Y" false-value="N" :disabled="user.company_id == 'minkhair' && (item.active_po_exists || item.on_hand > 0)" />Active</label
								>
							</td>
						</tr>
					</tbody>
				</table>

				<div class="view_bottom_bt" style="padding-top:5px;">
					<!-- <a href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" style="margin-right:15px;" @click="Inventory()">Save</a> -->
					<!-- <a v-if="modifiable" href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a> -->
					<a v-if="modifiable" href="javascript:;" class="search_bt" @click="submit()">Save</a>
					<!-- <button v-if="modifiable" class="'btn search_bt'" :disabled="!isValid" @click="submit()">Save</button> -->
					<!-- <a v-if="modifiable" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a> -->
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Adjust'" :draggable="false">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Inventory Adjust Overview</template>
			<template slot="body">
				<div style="width:800px; height:600px;" v-on:keyup.esc="close()">
					<div class="al_center" style="padding-top:20px;">
						<h1>
							Are you sure you want to change the inventory status of item(s) below?<br />
							This action is irreversible.
						</h1>
					</div>
					<div style="padding-top:50px;padding-left:150px;width:790px; height:480px;overflow-y: scroll;">
						<table class="view_tbl2" border="0" style="border-collapse: separate;   border-spacing: 10px 10px;">
							<colgroup>
								<col style="width:110px;" />
								<col style="width:90px;" />
								<col style="width:250px;" />
								<col style="width:250px;" />
							</colgroup>
							<tbody>
								<tr v-for="item in adjust_items" v-bind:key="item.item_id">
									<td>
										<h2 style="color:blue;">{{ item.item_code }}</h2>
									</td>
									<td><h2>-></h2></td>
									<td>
										<h2>
											WH1: <span :style="item.wh1_change > 0 ? 'color:green;' : item.wh1_change < 0 ? 'color:red;' : 'color:black;'"> {{ item.wh1_change > 0 ? '+' : '' }}{{ item.wh1_change }}</span>
										</h2>
									</td>
									<td>
										<h2>
											WH2: <span :style="item.wh2_change > 0 ? 'color:green;' : item.wh2_change < 0 ? 'color:red;' : 'color:black;'"> {{ item.wh2_change > 0 ? '+' : '' }}{{ item.wh2_change }}</span>
										</h2>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="popup_bottom">
						<a href="javascript:;" @click="adjustInventoryFromPopup()" class="search_bt">Continue</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeBulkPictureModal" v-if="showModal && modalName == 'BulkPicture'" :draggable="false">
			<template slot="title">Bulk Upload Pictures</template>
			<template slot="body">
				<div style="width:700px; min-height:400px; padding:15px;">
					<div v-if="bulk_picture_phase == 'preview'">
						<h2 style="margin-bottom:10px;">Selected {{ bulk_picture_files.length }} image file(s) from folder</h2>
						<p style="color:#666; margin-bottom:10px;">
							File names (without extension) will be matched against Item Code.<br />
							Supported formats: jpg, jpeg, png, gif, bmp, webp
						</p>
						<div style="max-height:300px; overflow-y:auto; border:1px solid #ddd; padding:10px;">
							<table style="width:100%; table-layout:fixed;">
								<colgroup>
									<col />
									<col style="width:35%;" />
									<col style="width:90px;" />
								</colgroup>
								<thead>
									<tr style="background:#f5f5f5;">
										<th style="text-align:left; padding:5px;">File Name</th>
										<th style="text-align:left; padding:5px;">Item Code</th>
										<th style="text-align:right; padding:5px;">Size</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(f, idx) in bulk_picture_files" :key="idx">
										<td style="padding:5px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ f.name }}</td>
										<td style="padding:5px; color:blue; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ bulkPictureItemCode(f.name) }}</td>
										<td style="padding:5px; text-align:right; white-space:nowrap;">{{ (f.size / 1024).toFixed(1) }} KB</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="popup_bottom" style="margin-top:15px;">
							<a href="javascript:;" class="search_bt" :class="bulk_picture_uploading ? 'disable_bt' : 'search_bt'" @click="bulkPictureUpload()">Upload</a>
							<a href="javascript:;" class="gray_bt" @click="closeBulkPictureModal()">Cancel</a>
						</div>
					</div>
					<div v-else-if="bulk_picture_phase == 'uploading'" class="al_center" style="padding:80px 0;">
						<h2>Uploading batch {{ bulk_picture_progress_current }} / {{ bulk_picture_progress_total }}...</h2>
						<p style="color:#666; margin-top:10px;">Processed {{ bulk_picture_processed }} of {{ bulk_picture_files.length }} files</p>
					</div>
					<div v-else-if="bulk_picture_phase == 'result'">
						<h2 style="margin-bottom:10px;">Upload Result</h2>
						<div style="margin-bottom:15px;">
							<span style="color:green; margin-right:20px;">Success: {{ bulk_picture_result.success_count }}</span>
							<span style="color:orange; margin-right:20px;">Not Found: {{ bulk_picture_result.not_found_count }}</span>
							<span style="color:red;">Failed: {{ bulk_picture_result.failed_count }}</span>
						</div>
						<div style="max-height:350px; overflow-y:auto; border:1px solid #ddd; padding:10px;">
							<table style="width:100%;">
								<thead>
									<tr style="background:#f5f5f5;">
										<th style="text-align:left; padding:5px;">File</th>
										<th style="text-align:left; padding:5px;">Item Code</th>
										<th style="text-align:left; padding:5px;">Status</th>
										<th style="text-align:left; padding:5px;">Message</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(r, idx) in bulk_picture_result.items" :key="idx">
										<td style="padding:5px;">{{ r.filename }}</td>
										<td style="padding:5px;">{{ r.item_code }}</td>
										<td style="padding:5px;" :style="'color:' + (r.status == 'success' ? 'green' : r.status == 'not_found' ? 'orange' : 'red')">{{ r.status }}</td>
										<td style="padding:5px;">{{ r.msg || '' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="popup_bottom" style="margin-top:15px;">
							<a href="javascript:;" class="search_bt" @click="closeBulkPictureModal()">Close</a>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick, isNumeric } from '@/utils/etc.js';
import {
	apiIndex,
	apiSelectItemList,
	apiSelectItemInventoryList,
	apiCheckItemExists,
	apiInsertItem,
	apiUpdateItem,
	apiDeleteItem,
	apiInsertPicture,
	apiDeletePicture,
	apiBulkUploadPictures,
	apiGetNewBarcode,
	apiCheckImportFromExcel,
	apiImportFromExcel,
	apiBatchInactivate,
	apiBatchActivate,
} from '@/api/item/master.js';
import { apiAdjustBatch } from '@/api/item/inventory.js';
import { apiUploadFile, apiDownloadFile } from '@/api/util.js';
import _ from 'lodash';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CodeSelect from '@/components/common/CodeSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import Modal from '@/components/common/Modal';

import XLSX from 'xlsx-js-style';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import { apiGetShopifyStoreList, apiSetThirdPartyStoreSetting } from '@/api/shopify/shopify_common.js';
import { apiGetExcelComparingAllProduct } from '@/api/shopify/shopify_item.js';

export default {
	data: function() {
		return {
			uri: null,
			classGroups: [],
			categories: [],
			//itemClasses: [],
			colors: [],
			sizes: [],
			units: [],
			locations: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			list_count: 0,

			classGroup: null,
			category_code: null,
			itemClass: null,

			null_barcode: false,
			keyword: '',
			rack: '',
			section: '',
			color_code: null,
			closed_yn: 'N',
			active_yn: 'Y',
			mode: null,
			all_selected: false,
			on_hand_condition: null,
			on_hand_quantity: 0,
			under_reorder_level: false,

			adjust_reason: null,

			items: [],
			selectedItem: {},

			item: {},

			fob_cost_link: null,

			changed_color_name: null,

			// Shopify
			selected_store_no: null,
			shopify_store_list: [],

			item_classes_string: '',
			item_class_component_key: 0,

			adjust_items: [],
			adjust_param: {},
			showModal: false,
			modalName: null,

			bulk_picture_files: [],
			bulk_picture_phase: 'preview',
			bulk_picture_uploading: false,
			bulk_picture_result: { items: [], success_count: 0, not_found_count: 0, failed_count: 0 },
			bulk_picture_progress_current: 0,
			bulk_picture_progress_total: 0,
			bulk_picture_processed: 0,
		};
	},
	props: ['headers'],
	watch: {
		items: {
			deep: true,
			handler: function() {
				//var vm = this;
				this.items.forEach(function(item) {
					// if (vm.user.company_id == 'jc') {
					// 	item.new_on_hand = item.WH1_new ? item.WH1_new : 0;
					// 	item.new_on_hand += item.WH2_new ? item.WH2_new : 0;
					// 	item.new_on_hand += item.WH_NULL_new ? item.WH_NULL_new : 0;
					// }

					if (item.on_hand != item.new_on_hand) item.changed = true;
					else item.changed = false;

					if (item.WH1_new != item.WH1) item.WH1_changed = true;
					else item.WH1_changed = false;

					if (item.WH2_new != item.WH2) item.WH2_changed = true;
					else item.WH2_changed = false;

					if (item.WH_NULL_new != item.WH_NULL) item.WH_NULL_changed = true;
					else item.WH_NULL_changed = false;
				});
			},
		},
		selected_store_no: {
			handler() {
				this.setThirdPartyStoreSetting();
			},
		},
	},
	// watch: {
	// 	item: {
	// 		deep: true,
	// 		handler: function(newVal, oldVal) {
	// 			console.log(newVal, oldVal);
	// 			if (newVal.class_code != oldVal.class_code) {
	// 				console.log('class code changed from', oldVal.class_code, newVal.class_code);
	// 			}
	// 		},
	// 	},
	// },

	computed: {
		user: function() {
			return this.$session.get('user');
		},
		isJC() {
			return this.$session.get('user').company_id == 'jc' ? true : false;
		},
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		profile: function() {
			return this.$session.get('profile');
		},
		isValid() {
			//return true;
			if (!this.item.item_code) return false;
			else return true;
		},
		isDeletable() {
			// return true;
			if (this.mode == 'detail' && this.selectedItem) return true;
			else return false;
		},
		computedName() {
			return this.item.class_name + '-' + this.item.color_code;
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		showCreateBarcodeButton() {
			if (this.user.company_id == 'jc') return false;

			return this.mode === 'add' || (this.mode === 'detail' && this.selectedItem && this.item && this.selectedItem.item_id && this.item.item_id && !this.selectedItem.barcode);
		},
		use_shopify() {
			return this.profile.shopify === 'Y';
		},
	},
	components: {
		Paging,
		PageSizeSelect,
		CodeSelect,
		ItemClassSelect,
		ItemClassSelectMultiS,
		Modal,
	},
	methods: {
		calNewOnHand(item) {
			item.new_on_hand = item.WH1 ? item.WH1 : 0;
			item.new_on_hand += item.WH2 ? item.WH2 : 0;
			item.new_on_hand += item.WH_NULL ? item.WH_NULL : 0;
		},
		readFile(event) {
			if (event.target.files.length == 0) return;
			var file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = e => {
				let data = e.target.result;
				data = new Uint8Array(data); // get excel file
				let excelFile = XLSX.read(data, { type: 'array', raw: true });

				let sheetName = excelFile.SheetNames[0];
				const rows = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1, raw: false });
				this.load(rows);
			};
			reader.readAsArrayBuffer(file);
		},
		async load(rows) {
			var excel_items = [];
			for (var i = 1; i < rows.length; i++) {
				if (rows[i][2]) {
					excel_items.push({
						row_no: i + 1,
						class_code: rows[i][0],
						class_name: rows[i][1],
						item_code: rows[i][2],
						color_code: rows[i][3],
						name: rows[i][4],
						packing: rows[i][5],
						unit_code: rows[i][6],
						lock_price: rows[i][7],
						min_price: rows[i][8],
						cost: rows[i][9],
						location_code: rows[i][10],
						rack: rows[i][11],
						section: rows[i][12],
						barcode: rows[i][13],
						on_hand: rows[i][14],
						active_yn: rows[i][15],
					});
				}
			}

			if (excel_items.length == 0) {
				this.$toast.error('No valid data found');

				this.$refs.import_file.value = null;
				return;
			}

			//console.log(excel_items);
			var msg = '';

			if (excel_items.filter(i => !i.name || !i.class_code).length > 0) {
				this.$toast.error('Item with empty item name or class code exists');

				this.$refs.import_file.value = null;
				return;
			}

			const lookup = excel_items.reduce((a, e) => {
				a[e.item_code] = ++a[e.item_code] || 0;
				return a;
			}, {});

			if (excel_items.filter(e => lookup[e.item_code]).length > 0) {
				msg = 'Duplicate item code from excel file found.<br>';
				excel_items
					.filter(e => lookup[e.item_code])
					.forEach(i => {
						msg += '<br>Excel row ' + i.row_no + ', item code = ' + i.item_code;
					});
				this.$alertify.alert('Excel Import', msg);

				this.$refs.import_file.value = null;
				return;
			}
			//console.log(excel_items.filter(e => lookup[e.item_code]));

			const { data } = await apiCheckImportFromExcel({
				for_import: true,
				excel_json_str: JSON.stringify(excel_items),
			});

			//console.log(data);
			if (!data.result) {
				msg = 'Duplicate item code or barcode from existing data found.<br>';
				data.dup_list.forEach(i => {
					msg += '<br>Excel row ' + i.excel_row_no + ', item code = ' + i.item_code + ', barcode = ' + i.barcode;
				});
				this.$alertify.alert('Excel Import', msg);

				this.$refs.import_file.value = null;
				return;
			}

			this.$alertify.confirm(
				'No error found. Sure to proceed?',
				() => {
					this.confirmImport(excel_items);
				},
				() => {
					this.$refs.import_file.value = null;
				},
			);
			/*
			var valid_items = data.excelItemList.filter(i => i.active_yn == 'Y' && i.class_active_yn == 'Y' && i.class_closed_yn == 'N' && !i.so_blocked);
			var invalid_items = data.excelItemList.filter(i => i.active_yn == 'N' || i.class_active_yn == 'N' || i.class_closed_yn == 'Y' || i.so_blocked);
			var not_found_items = data.excelItemList.filter(i => !i.item_id);
			var msg = '';
			msg = 'Excel items : ' + excel_items.length + '<br>';
			msg += 'Valid items : ' + valid_items.length + '<br>';
			msg += 'Invalid items : ' + invalid_items.length + '<br>';
			msg += 'Not found items : ' + not_found_items.length + '<br>';

			invalid_items.forEach(i => {
				msg += '<br>Invalid item: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				if (i.active_yn == 'N' || i.class_active_yn == 'N') msg += ', Inactive';
				if (i.class_closed_yn == 'Y') msg += ', Closed';
				if (i.so_blocked) msg += ', Blocked';
			});

			not_found_items.forEach(i => {
				msg += '<br>Not found item: excel row ' + i.excel_row_no;
			});

			var vm = this;
			var to_add_items = [];
			valid_items.forEach(i => {
				if (vm.user.to_lock_price_adjust_yn == 'N' && i.excel_price < i.lock_price) {
					msg += '<br>Lower than lock price: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				} else {
					i.quantity_abs = i.excel_quantity;
					if (vm.user.company_id == 'newjigu') {
						i.unit_price = i.b_price;
						i.r_price = i.excel_price;
					} else {
						i.unit_price = i.excel_price;
						i.r_price = i.excel_req_price;
					}
					i.last_price = i.last_net_price;
					to_add_items.push(_.cloneDeep(i));
				}
			});

			this.mergeItems(to_add_items);

			this.$alertify.alert('Excel Import', msg); */
		},
		async confirmImport(excel_items) {
			const { data } = await apiImportFromExcel({
				for_import: true,
				excel_items: excel_items,
			});

			this.$refs.import_file.value = null;

			if (data.result) {
				this.$toast.success('Imported successfully');
				this.search();
			}
		},
		getPricePercent(price) {
			if (price > 0 && this.item.cost > 0) {
				if (this.user.company_id == 'he') return ((100 * (price - this.item.cost)) / this.item.cost).toFixed(0);
				else return ((100 * (price - this.item.cost)) / price).toFixed(0);
			} else return null;
		},
		async createBarcode() {
			const { data } = await apiGetNewBarcode();
			this.item.barcode = data;
		},
		async excelComparingWithShopify() {
			this.$toast.warning('Export to Excel takes time. Please be patient...', { duration: 10000 });

			const { data } = await apiGetExcelComparingAllProduct(this.selected_store_no);
			if (data.result !== 'SUCCESS') {
				this.$toast.error(data.msg);
				return;
			}

			const file_name = data.excel_file_name;
			if (file_name) await apiDownloadFile(file_name, 'VS_ShopifyProduct.xlsx');
		},
		async excelData() {
			var param = {
				class_group: this.classGroup,
				category_code: this.category_code,
				class_code: this.itemClass,
				keyword: this.keyword,
				rack: this.rack,
				section: this.section,

				paging_yn: 'N',

				closed_yn: this.closed_yn,
				active_yn: this.active_yn,

				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,
			};

			if (this.null_barcode) param.null_barcode = true;
			if (this.under_reorder_level) param.under_reorder_level = true;

			if (this.user.company_id == 'jc') {
				param.include_po_quantity = true;
				param.for_puchase = true;
				param.include_avg_cost = true;
			}

			const { data } = await apiSelectItemList(param);

			return data;
		},
		async excelSBM() {
			const data = await this.excelData();

			let header = [
				{ key: 'factory_code', name: 'P. Line', width: 15, dataType: defaultDataType.string },
				{ key: 'class_category_code', name: 'Category 1', width: 15, dataType: defaultDataType.string },
				{ key: '', name: 'Category 2', width: 15, dataType: defaultDataType.string },
				{ key: 'class_group_code', name: 'Group', width: 15, dataType: defaultDataType.string },
				{ key: 'unit_note1', name: 'Vendor 1', width: 14, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item #', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Description', width: 60, dataType: defaultDataType.string },
				{ key: 'on_hand', name: 'Stock', width: 8, dataType: defaultDataType.currency },
				{ key: 'unit_name', name: 'U/M', width: 5, dataType: defaultDataType.string },
				{ key: 'po_quantity', name: 'Qty On P.O', width: 10, dataType: defaultDataType.currency },
				{ key: 'b_price', name: 'Price', width: 8, dataType: defaultDataType.currency },
				{ key: 'min_price', name: 'Min Price', width: 8, dataType: defaultDataType.currency },
				{ key: 'last_sh_price', name: 'Last Cost', width: 8, dataType: defaultDataType.currency },
				{ key: '', name: 'Std Cost', width: 8, dataType: defaultDataType.currency },
				{ key: 'avg_cost', name: 'Avg Cost', width: 8, dataType: defaultDataType.currency },
				{ key: 'rack', name: 'Lot #', width: 10, dataType: defaultDataType.string },
				{ key: 'barcode_box', name: 'Barcode #', width: 15, dataType: defaultDataType.string },
			];
			exportDataExcel(data.itemList, header, 'ItemMasterSBM');
		},
		async excel() {
			const data = await this.excelData();

			let header = [
				{ key: 'item_id', name: 'Item ID', width: 15 },
				{ key: 'item_code', name: 'Item Code', width: 15 },
				{ key: 'color_code', name: 'Color', width: 15 },
				{ key: 'name', name: 'Item Name', width: 60 },
				{ key: 'packing', name: 'Pack', width: 5, dataType: defaultDataType.currency },
				{ key: 'unit_name', name: 'Unit', width: 5 },
				{ key: 'lock_price', name: 'Lock($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'min_price', name: 'Min($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'b_price', name: 'B P.($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'cost', name: 'Cost($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'location_name', name: 'Location', width: 20 },
				{ key: 'rack', name: 'Rack', width: 10 },
				{ key: 'section', name: 'Section', width: 10 },
				{ key: 'barcode', name: 'Barcode', width: 15 },
				{ key: 'on_hand', name: 'On Hand', width: 8, dataType: defaultDataType.currency },
				{ key: 'active_yn', name: 'Active', width: 8 },
			];
			if (this.profile.use_size_code == 'Y') header.splice(3, 0, { key: 'size', name: 'Size', width: 10 });

			if (this.user.cost_view_yn !== 'Y') header = header.filter(item => item.key !== 'cost');

			if (this.user.company_id == 'he') {
				header = header.filter(item => item.key !== 'lock_price' && item.key !== 'min_price');
				// Item Code 뒤에 Factory Code 추가
				const item_code_idx = header.findIndex(h => h.key === 'item_code');
				if (item_code_idx > -1) {
					header.splice(item_code_idx + 1, 0, { key: 'factory_code', name: 'Factory Code', width: 15 });
				}
			} else {
				header = header.filter(item => item.key !== 'b_price');
			}

			if (this.user.company_id == 'beautyplus' && (this.user.admin_yn == 'Y' || this.user.dept_code == '3500')) {
				header.splice(8, 0, { key: 's_price', name: 'S P.($)', width: 8 });
				header.splice(9, 0, { key: 'a_price', name: 'A P.($)', width: 8 });
				header.splice(10, 0, { key: 'b_price', name: 'B P.($)', width: 8 });
				header.splice(11, 0, { key: 'c_price', name: 'C P.($)', width: 8 });
				header.splice(12, 0, { key: 'fob', name: 'FOB($)', width: 8 });
				header.splice(13, 0, { key: 'tariff_rate', name: 'Tariff(%)', width: 9 });
			}

			exportDataExcel(data.itemList, header, 'ItemMaster');
		},

		async inventoryReport() {
			var param = {
				class_code: this.itemClass,
				keyword: this.keyword,
				rack: this.rack,
				section: this.section,

				paging_yn: 'N',

				closed_yn: this.closed_yn,
				active_yn: this.active_yn,

				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,
			};

			if (this.null_barcode) param.null_barcode = true;
			if (this.under_reorder_level) param.under_reorder_level = true;

			if (this.user.company_id == 'arkin') param.include_inventory_value = true;

			const { data } = await apiSelectItemInventoryList(param);

			let total_count = 0;
			let total_value = 0;
			let itemInventoryList = data.itemInventoryList;
			itemInventoryList.forEach(i => {
				i.stock_value = i.on_hand * i.avg_cost;
				total_count += i.on_hand;
				total_value += i.stock_value;
			});

			itemInventoryList.push({ name: 'Total', on_hand: total_count, stock_value: total_value });
			//console.log(data);

			let header = [
				{ key: 'item_code', name: 'Item Code', width: 20 },
				{ key: 'name', name: 'Item Name', width: 70 },
				{ key: 'on_hand', name: 'Stock', width: 8, dataType: defaultDataType.currency },
				{ key: 'lock_price', name: 'Lock($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'min_price', name: 'Min($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'a_price', name: 'A P.($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'b_price', name: 'B P.($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'c_price', name: 'C P.($)', width: 8, dataType: defaultDataType.currency },
				{ key: 'avg_cost', name: 'Avg Cost($)', width: 10, dataType: defaultDataType.currency },
				{ key: 'stock_value', name: 'Stock Value($)', width: 10, dataType: defaultDataType.currency },
			];

			exportDataExcel(itemInventoryList, header, 'ItemInventory');
		},
		adjustCost(item) {
			if (!this.fob_cost_link) return;

			item.cost = item.fob + item.fob * item.tariff_rate * 0.01;
		},
		adjustPrice(item) {
			if (this.profile.auto_pricing != 'Y') return;

			item.lock_price = item.cost * 1.1;
			item.min_price = item.cost * 1.2;
			item.s_price = item.cost * 1.3;
			item.a_price = item.cost * 1.5;
			item.b_price = item.cost * 1.6;
			item.c_price = item.cost * 2;
		},
		syncMinPriceFromA(item) {
			if (this.user.company_id != 'jc') return;
			item.min_price = item.a_price;
		},
		getImageUrl(it) {
			var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + it.image_file_name;
			return url;
		},
		async clear() {
			if (confirm('Are you sure to delete the picture?')) {
				var picture = {
					item_id: this.item.item_id,
				};
				var response = await apiDeletePicture(picture);
				if (response.data.result) {
					this.$toast.success('File deleted successfully');
					this.item.image_file_name = null;
					this.selectedItem.image_file_name = null;
				}
			}
		},
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			var file = this.$refs.uploadFile.files[0];
			var response = await apiUploadFile(file);
			if (response.data.result) {
				var newFilename = response.data.filename;
				//this.$toast.success('File uploaded successfully');
				//console.log(newFilename);
				var picture = {
					item_id: this.item.item_id,
					image_file_name: newFilename,
				};
				response = await apiInsertPicture(picture);
				if (response.data.result) {
					this.$toast.success('File uploaded successfully');
					this.item.image_file_name = newFilename;
					this.selectedItem.image_file_name = newFilename;
					this.$refs.uploadFile.value = null;
				}
			}
		},
		bulkPictureFolderPick() {
			this.$refs.bulkPictureInput.value = null;
			this.$refs.bulkPictureInput.click();
		},
		bulkPictureItemCode(filename) {
			if (!filename) return '';
			var dot_idx = filename.lastIndexOf('.');
			return dot_idx > 0 ? filename.substring(0, dot_idx) : filename;
		},
		bulkPictureFolderSelected() {
			var all_files = Array.from(this.$refs.bulkPictureInput.files || []);
			var image_exts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
			var image_files = all_files.filter(function(f) {
				var dot_idx = f.name.lastIndexOf('.');
				if (dot_idx < 0) return false;
				var ext = f.name.substring(dot_idx + 1).toLowerCase();
				return image_exts.indexOf(ext) >= 0;
			});
			if (image_files.length == 0) {
				this.$toast.error('No image files found in the selected folder');
				return;
			}
			this.bulk_picture_files = image_files;
			this.bulk_picture_phase = 'preview';
			this.bulk_picture_uploading = false;
			this.bulk_picture_result = { items: [], success_count: 0, not_found_count: 0, failed_count: 0 };
			this.showModal = true;
			this.modalName = 'BulkPicture';
		},
		async bulkPictureUpload() {
			if (this.bulk_picture_uploading) return;
			this.bulk_picture_uploading = true;
			this.bulk_picture_phase = 'uploading';

			// Split into batches of ~50MB each (server max-request-size is 100MB)
			var MAX_BATCH_SIZE = 50 * 1024 * 1024;
			var batches = [];
			var current_batch = [];
			var current_size = 0;
			this.bulk_picture_files.forEach(function(f) {
				if (current_size + f.size > MAX_BATCH_SIZE && current_batch.length > 0) {
					batches.push(current_batch);
					current_batch = [];
					current_size = 0;
				}
				current_batch.push(f);
				current_size += f.size;
			});
			if (current_batch.length > 0) batches.push(current_batch);

			this.bulk_picture_progress_total = batches.length;
			this.bulk_picture_progress_current = 0;
			this.bulk_picture_processed = 0;

			var agg = { items: [], success_count: 0, not_found_count: 0, failed_count: 0 };

			try {
				for (var i = 0; i < batches.length; i++) {
					this.bulk_picture_progress_current = i + 1;
					var batch = batches[i];
					try {
						var response = await apiBulkUploadPictures(batch);
						if (response.data.result) {
							agg.items = agg.items.concat(response.data.items || []);
							agg.success_count += response.data.success_count || 0;
							agg.not_found_count += response.data.not_found_count || 0;
							agg.failed_count += response.data.failed_count || 0;
						} else {
							batch.forEach(f => {
								agg.items.push({ filename: f.name, item_code: this.bulkPictureItemCode(f.name), status: 'failed', msg: 'Batch request failed' });
								agg.failed_count++;
							});
						}
					} catch (e) {
						batch.forEach(f => {
							agg.items.push({ filename: f.name, item_code: this.bulkPictureItemCode(f.name), status: 'failed', msg: 'Network/server error' });
							agg.failed_count++;
						});
					}
					this.bulk_picture_processed += batch.length;
				}

				this.bulk_picture_result = agg;
				this.bulk_picture_phase = 'result';
				this.$toast.success('Bulk upload completed');
				if (agg.success_count > 0) this.search();
			} finally {
				this.bulk_picture_uploading = false;
			}
		},
		closeBulkPictureModal() {
			this.showModal = false;
			this.modalName = null;
			this.bulk_picture_files = [];
			this.bulk_picture_phase = 'preview';
			this.$refs.bulkPictureInput.value = null;
		},
		async adjustInventory() {
			var item_data = [];

			if (this.user.company_id == 'jc') {
				this.items.forEach(function(item) {
					if (item.WH1_changed || item.WH2_changed || item.WH_NULL_changed) {
						var param_item = {
							item_code: item.item_code,
							item_id: item.item_id,
							wh1_before_quantity: item.WH1,
							wh1_after_quantity: item.WH1_new,
							wh2_before_quantity: item.WH2,
							wh2_after_quantity: item.WH2_new,
							wh_null_before_quantity: item.WH_NULL,
							wh_null_after_quantity: item.WH_NULL_new,
						};

						if (!param_item.wh1_before_quantity) param_item.wh1_before_quantity = 0;
						if (!param_item.wh1_after_quantity) param_item.wh1_after_quantity = 0;

						param_item.wh1_change = param_item.wh1_after_quantity - param_item.wh1_before_quantity;

						if (!param_item.wh2_before_quantity) param_item.wh2_before_quantity = 0;
						if (!param_item.wh2_after_quantity) param_item.wh2_after_quantity = 0;

						param_item.wh2_change = param_item.wh2_after_quantity - param_item.wh2_before_quantity;

						if (!param_item.wh_null_before_quantity) param_item.wh_null_before_quantity = 0;
						if (!param_item.wh_null_after_quantity) param_item.wh_null_after_quantity = 0;

						param_item.wh_null_change = param_item.wh_null_after_quantity - param_item.wh_null_before_quantity;

						item_data.push(param_item);
					}
				});
			} else {
				this.items.forEach(function(item) {
					if (item.changed) {
						var param_item = {
							item_id: item.item_id,
							before_quantity: item.on_hand,
							after_quantity: item.new_on_hand,
						};

						if (!param_item.before_quantity) param_item.before_quantity = 0;
						if (!param_item.after_quantity) param_item.after_quantity = 0;

						item_data.push(param_item);
					}
				});
			}

			if (item_data.length == 0) {
				this.$toast.error('Nothing to adjust');
				return;
			}

			if (!this.adjust_reason) {
				this.$toast.error('Select reason');
				return;
			}

			var param = {
				adjust_reason: this.adjust_reason,
				items: item_data,
			};

			if (this.user.company_id == 'jc') {
				param.each_warehouse = true;
				param.create_transaction = true;
				param.memo = 'adjust';

				this.adjust_items = item_data;
				this.adjust_param = param;
				this.showModal = true;
				this.modalName = 'Adjust';
			} else {
				await this.adjustInventoryConfirm(param);
			}

			// console.log(param);
			// const dummy = true;
			// if (dummy) return;

			// const { data } = await apiAdjustBatch(param);

			// if (data.result) {
			// 	this.$toast.success('Saved successfully');
			// 	this.selectItems();
			// } else {
			// 	this.$toast.error(data.msg);
			// }
		},
		async adjustInventoryFromPopup() {
			this.showModal = false;
			await this.adjustInventoryConfirm(this.adjust_param);
		},
		async adjustInventoryConfirm(param) {
			const { data } = await apiAdjustBatch(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectItems();
			} else {
				this.$toast.error(data.msg);
			}
		},
		closeModal() {
			this.showModal = false;
		},
		setSearchClass(ic) {
			//console.log(itemClass);
			this.itemClass = ic.code;
			this.search();
		},
		setItemClass(itemClass) {
			if (this.mode == 'add' && itemClass) {
				//console.log(itemClass);
				this.item.class_name = itemClass.name;
				this.setDefaultItemCodeAndName();
			}
		},
		setColor(color) {
			if (this.mode == 'add') {
				this.setDefaultItemCodeAndName(this.item.size_name);
			}

			this.changed_color_name = color ? color.name : null;
		},
		setSize(size) {
			if (this.mode == 'add') {
				this.setDefaultItemCodeAndName(size.name);
			}
		},
		setDefaultItemCodeAndName(size_name) {
			if (typeof this.item.class_code == 'undefined') return;
			if (this.user.company_id != 'jc' && typeof this.item.color_code == 'undefined') return;

			if (this.item.class_code && this.item.color_code) {
				this.item.item_code = this.item.class_code + '-' + this.item.color_code;

				this.item.name = this.item.class_name + '-' + this.item.color_code;
			} else if (this.user.company_id == 'jc' && this.item.class_code) {
				this.item.item_code = this.item.class_code;

				this.item.name = this.item.class_name;
			} else {
				this.item.item_code = null;

				this.item.name = null;
			}

			if (this.profile.use_size_code == 'Y' && typeof this.item.color_code != 'undefined') {
				this.item.item_code = this.item.item_code + '-' + this.item.size_code;
				if (typeof size_name != 'undefined') this.item.name = this.item.name + ' (' + size_name + ')';
			}

			this.$forceUpdate();
		},
		add() {
			this.mode = 'add';
			this.item = {
				barcode: null,
				active_yn: 'Y',
				purchase_unit_code: this.user.company_id == 'jc' ? 'BX' : null,
			};

			this.selectedItem = {};
			this.$refs.code.focus();
		},
		toggleSelectAll() {
			this.items.forEach(it => {
				this.$set(it, 'selected', this.all_selected);
			});
		},
		getSelectedItemIds() {
			return this.items.filter(it => it.selected).map(it => it.item_id);
		},
		async inactivateSelected() {
			const item_ids = this.getSelectedItemIds();
			if (item_ids.length == 0) {
				this.$toast.error('No items selected');
				return;
			}
			if (!confirm(item_ids.length + ' item(s) will be set INACTIVE. Continue?')) return;

			const response = await apiBatchInactivate({ item_ids });
			if (response.data.result) {
				this.$toast.success(response.data.count + ' item(s) inactivated');
				this.all_selected = false;
				this.search();
			} else {
				this.$toast.error('Failed');
			}
		},
		async activateSelected() {
			const item_ids = this.getSelectedItemIds();
			if (item_ids.length == 0) {
				this.$toast.error('No items selected');
				return;
			}
			if (!confirm(item_ids.length + ' item(s) will be set ACTIVE. Continue?')) return;

			const response = await apiBatchActivate({ item_ids });
			if (response.data.result) {
				this.$toast.success(response.data.count + ' item(s) activated');
				this.all_selected = false;
				this.search();
			} else {
				this.$toast.error('Failed');
			}
		},
		clone() {
			this.mode = 'add';
			this.item.item_id = '';
			this.item.item_code = '';
			this.selectedItem = {};
			this.$refs.code.focus();

			this.setDefaultItemCodeAndName(this.item.size_name);
		},
		inventoryHistory() {
			//console.log(this.item.item_id);
			this.$router.push({ name: 'inventoryHistory', params: {}, query: { backUri: this.uri, item_id: this.item.item_id } });
		},
		viewLot() {
			//this.$router.push({ name: 'inventoryDetail', params: {}, query: { backUri: this.uri, item_id: this.item.item_id } });
			let routeData = this.$router.resolve({ name: 'inventoryDetail', params: {}, query: { backUri: this.uri, item_id: this.item.item_id } });
			window.open(routeData.href, 'herp_lot');
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Item Code');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckItemExists(this.item);
			return data.result;
		},
		search() {
			this.page_no = 1;
			this.selectItems();
		},
		reset() {
			this.page_no = 1;
			this.active_yn = 'Y';
			this.keyword = '';
			this.color_code = null;
			this.null_barcode = false;
			this.under_reorder_level = false;
			this.rack = '';
			this.section = '';
			this.itemClass = null;
			this.classGroup = null;
			this.category_code = null;

			this.search();
		},
		async selectItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			this.mode = 'detail';
			this.item = {};
			this.selectedItem = {};

			var param = {
				class_group: this.classGroup,
				category_code: this.category_code,
				class_code: this.itemClass,
				color_code: this.color_code,
				keyword: this.keyword,
				rack: this.rack,
				section: this.section,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				closed_yn: this.closed_yn,
				active_yn: this.active_yn,

				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,

				active_po_check: true,
			};

			//console.log(this.item_classes_string);
			if (this.item_classes_string) param.item_classes = this.item_classes_string.split(',');

			if (this.null_barcode) param.null_barcode = true;
			if (this.under_reorder_level) param.under_reorder_level = true;
			if (this.user && this.user.cost_view_yn == 'Y' && this.user.fob_price_view) param.last_sh_price_with_modification_reflected = true;
			const { data } = await apiSelectItemList(param);

			//console.log(data);
			this.items = data.itemList;
			if (this.user.company_id == 'jc') {
				this.items.forEach(function(item) {
					/* jc의 경우 warehouse별 on_hand 처리를 위해, locatino code가 고정된 걸로 가정함 */
					item.WH1 = null;
					item.WH2 = null;
					item.WH_NULL = null;
					if (item.wh_on_hand_str) {
						const wh_on_hands = item.wh_on_hand_str.split('||');
						wh_on_hands.forEach(woh => {
							const ohs = woh.split('|');

							if (ohs.length == 2) {
								if (ohs[0] == 'WH1') {
									item.WH1 = Number(ohs[1]);
									item.WH1_new = Number(ohs[1]);
								} else if (ohs[0] == 'WH2') {
									item.WH2 = Number(ohs[1]);
									item.WH2_new = Number(ohs[1]);
								} else if (ohs[0] == 'WH_NULL') {
									item.WH_NULL = Number(ohs[1]);
									item.WH_NULL_new = Number(ohs[1]);
								}
							}
						});
					}
				});
			}

			this.list_count = data.list_count;

			if (this.items.length == 1) {
				this.selectRow(this.items[0]);
			}

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			inputSelectOnClick();
			var uri = '/item/item_master?dummy=1';
			if (this.itemClass) uri += '&class_code=' + this.itemClass;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.page_no) uri += '&page_no=' + this.page_no;
			if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.active_yn) uri += '&active_yn=' + this.active_yn;
			if (this.null_barcode) uri += '&null_barcode=' + this.null_barcode;
			if (this.under_reorder_level) uri += '&under_reorder_level=' + this.under_reorder_level;

			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			// if (this.items.length > 0) this.selectRow(this.items[0]);
			// else this.selectedItem = {};
		},
		async checkValidity() {
			if (isNumeric(this.item.min_price) && isNumeric(this.item.lock_price) && this.item.min_price < this.item.lock_price) {
				this.$toast.error('Min price is smaller than lock price');
				return false;
			}

			if (isNumeric(this.item.a_price) && isNumeric(this.item.min_price) && this.item.a_price < this.item.min_price) {
				this.$toast.error('A price is smaller than min price');
				return false;
			}

			if (isNumeric(this.item.b_price) && isNumeric(this.item.a_price) && this.item.b_price < this.item.a_price) {
				this.$toast.error('B price is smaller than A price');
				return false;
			}

			if (isNumeric(this.item.c_price) && isNumeric(this.item.b_price) && this.item.c_price < this.item.b_price) {
				this.$toast.error('C price is smaller than B price');
				return false;
			}

			return true;
		},
		async submit() {
			if (!this.item.item_code) {
				this.$toast.error('Empty Item Code. Maybe due to invalid class code');
				return false;
			}

			if (!this.item.name) {
				this.$toast.error('Empty Name');
				return;
			}

			if (this.item.cost === null) {
				this.$toast.error('Empty Cost');
				return false;
			}

			if (!(await this.checkValidity())) return;

			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Item Code');
					return;
				}
				response = await apiInsertItem(this.item);
			} else {
				response = await apiUpdateItem(this.item);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.item.item_id = data.item_id;
					this.items.unshift(_.cloneDeep(this.item));
				}

				Object.assign(this.selectedItem, this.item);
				//console.log(this.selectedItem);
				this.selectedItem.color_name = this.changed_color_name;
				this.$forceUpdate();
				//this.setSelectedItem();

				this.mode = 'detail';
			} else {
				this.$toast.error(data.msg);
			}
		},
		async del() {
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteItem(this.item);

				if (data.result) {
					this.$toast.success('Deleted successfully');

					var vm = this;
					const idx = this.items.findIndex(function(item) {
						return item.item_id === vm.selectedItem.item_id;
					});
					this.items.splice(idx, 1);
					this.item = {};
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		gotoPage(pageNo) {
			//console.log('going to page', pageNo);
			//this.page_no = pageNo;
			this.selectItems(pageNo);
		},
		selectRow(item) {
			this.mode = 'detail';
			this.selectedItem = item;

			this.item = _.cloneDeep(item);
		},
		async setThirdPartyStoreSetting() {
			const { data } = await apiSetThirdPartyStoreSetting(this.selected_store_no);
			if (data.result !== 'SUCCESS') {
				this.$toast.error('Network Error.');
			}
		},
		async getShopifyStoreList() {
			const { data } = await apiGetShopifyStoreList();
			this.shopify_store_list = data || [];
			if (this.shopify_store_list.length > 0) this.selected_store_no = this.shopify_store_list[0].store_no;
		},
		async index() {
			const { data } = await apiIndex();

			//this.itemClasses = data.itemClassList;
			this.classGroups = data.classGroupList;
			this.categories = data.categoryList;
			this.colors = data.colorList;
			this.sizes = data.sizeList;
			this.units = data.unitList;
			this.locations = data.locationList;
			//console.log(this.itemClasses);

			//this.setDlOptions(this.dlClassGroup, data.classGroupList);
		},
		async init() {
			if (this.use_shopify) await this.getShopifyStoreList();

			await this.index();
			//if (this.$route.query.item_id) this.item_id = this.$route.query.item_id;
			if (this.$route.query.class_code) this.class_code = this.$route.query.class_code;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;
			if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;
			if (this.$route.query.null_barcode) this.null_barcode = this.$route.query.null_barcode;
			if (this.$route.query.under_reorder_level) this.under_reorder_level = this.$route.query.under_reorder_level;
			this.page_size = this.$store.getters['getDefaultPageSize'];

			await this.selectItems(this.$route.query.page_no);
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_item_master');
		this.$store.commit('setSubTitle', 'Item -> Item Masters');

		this.fob_cost_link = this.profile.fob_cost_link == 'Y' ? true : false;

		this.init();
		// this.selectItems();
		inputSelectOnClick();
	},
	mounted() {
		this.$nextTick(function() {
			inputSelectOnClick();
			//makeTableResizable();
		});
	},
};
</script>

<style></style>
